import { Controller } from "@hotwired/stimulus"

// Collapse / expand all coaching-report chapter bodies in the V4 notebook.
export default class extends Controller {
  static targets = ["body", "toggleLabel"]

  connect() {
    this.collapsed = false
  }

  toggleAll() {
    this.collapsed = !this.collapsed
    this.bodyTargets.forEach((body) =>
      body.classList.toggle("hidden", this.collapsed),
    )
    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.textContent = this.collapsed
        ? "Expand all"
        : "Collapse all"
    }
  }
}
